import { RcClasses } from '../../../../foundation';
export var RcToggleButtonClasses = RcClasses(['selected', 'disabled', 'label'], 'RcToggleButton');
export var RcToggleButtonSpace = {
    small: { area: 0.5, inner: 1, outer: 2 },
    medium: { area: 1, inner: 1, outer: 2 },
    large: { area: 1, inner: 2, outer: 4 },
};
